(function($) {

    var tables = document.querySelectorAll( '.entry-content table:not(.no-responsive)' );

    // ignore formbuilder forms
    for( var x = 0; x < tables.length; x++ ) {

        if ( ! tables[x].parentNode.classList.contains( 'formbuilder-embed' ) ) {
            $( tables[x] ).cardtable({
                myClass:'responsive-table'
            });
        }

    }

})(jQuery);
